import { useStore } from 'zustand';
import { getStoreByKey } from './store/CarouselStore';

const CarouselDirection = ({ uniqId }: { uniqId: string }) => {
  const { direction, dispatch } = useStore(getStoreByKey(uniqId));
  return (
    <div className="absolute right-4 bottom-0 hidden sm:block">
      <button
        aria-label="Set vertical direction"
        className="pr-2"
        onClick={() => dispatch({ type: 'DIRECTION', payload: 'vertical' })}
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 9H10.5V12H7.5V9Z"
            fill={direction === 'vertical' ? '#05141F' : '#9BA1A5'}
          />
          <path
            d="M12 14.25H22.5V15.75H12V14.25Z"
            fill={direction === 'vertical' ? '#05141F' : '#9BA1A5'}
          />
          <path
            d="M12 9.75H22.5V11.25H12V9.75Z"
            fill={direction === 'vertical' ? '#05141F' : '#9BA1A5'}
          />
          <path
            d="M12 18.75H22.5V20.25H12V18.75Z"
            fill={direction === 'vertical' ? '#05141F' : '#9BA1A5'}
          />
          <path
            d="M7.5 13.5H10.5V16.5H7.5V13.5Z"
            fill={direction === 'vertical' ? '#05141F' : '#9BA1A5'}
          />
          <path
            d="M7.5 18H10.5V21H7.5V18Z"
            fill={direction === 'vertical' ? '#05141F' : '#9BA1A5'}
          />
        </svg>
      </button>
      <button
        aria-label="Set horizontal direction"
        onClick={() => dispatch({ type: 'DIRECTION', payload: 'horizontal' })}
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.75 12.75H17.25V17.25H12.75V12.75ZM6.75 13.5H9.75V16.5H6.75V13.5ZM20.25 13.5H23.25V16.5H20.25V13.5Z"
            stroke={direction === 'horizontal' ? '#05141F' : '#9BA1A5'}
            strokeWidth="1.5"
          />
        </svg>
      </button>
    </div>
  );
};

export default CarouselDirection;
